import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { cn } from "./cn";

/**
 * Bun bottom sheet: the mobile-web detail surface. Spec: Component Library
 * "Bottom sheet, toasts & date picker". Scrim, grabber, 18px top radius;
 * content and footer actions are composed as children.
 *
 *   <BottomSheet open={open} onClose={...} aria-label="Transaction detail">
 *     ...rows...
 *     <div className="flex gap-2 mt-[6px]">
 *       <Button variant="secondary" className="flex-1">Add note</Button>
 *       <Button className="flex-1">Mark reviewed</Button>
 *     </div>
 *   </BottomSheet>
 */
export default function BottomSheet({ open, onClose, className, children, ...props }) {
  return (
    <Transition show={!!open} as={Fragment}>
      <Dialog onClose={onClose} className="relative z-50 font-instrument" {...props}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-150"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-[color:var(--bun-scrim)]" aria-hidden="true" />
        </Transition.Child>
        <div className="fixed inset-x-0 bottom-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-200"
            enterFrom="translate-y-full"
            enterTo="translate-y-0"
            leave="ease-in duration-150"
            leaveFrom="translate-y-0"
            leaveTo="translate-y-full"
          >
            <Dialog.Panel
              className={cn(
                "mx-auto w-full max-w-[560px] bg-bun-surface text-bun-text",
                "rounded-t-[18px] shadow-bun-sheet px-[18px] pt-[10px] pb-[18px]",
                className
              )}
            >
              <div aria-hidden="true" className="w-9 h-1 rounded-full bg-bun-track-off mx-auto mb-[14px]" />
              {children}
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}
